import { Component, computed, inject } from '@angular/core';

import { SelfserviceStore } from '@app/stores/selfserviceStore';
import { SelfserviceTimerComponent } from '../selfservice-timer/selfservice-timer.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-selfservice-header',
    templateUrl: './selfservice-header.component.html',
    styleUrls: ['./selfservice-header.component.scss'],
    imports: [SelfserviceTimerComponent, TranslateModule],
})
export class SelfserviceHeaderComponent {
    private selfserviceStore = inject(SelfserviceStore);
    headerName = computed(() => this.selfserviceStore.organizationSite()?.name ?? '');
}
